import { API, Auth } from "aws-amplify";

const normalizeLoanKbankId = (loanKbankId) => {
  if (loanKbankId === undefined || loanKbankId === null) {
    return "";
  }
  return String(loanKbankId).trim();
};

export const getBuroBanIds = (items = []) => {
  return new Set(
    items
      .filter((item) => item?.buro_status === "BAN")
      .map((item) => normalizeLoanKbankId(item?.loan_kbank_id))
      .filter((loanKbankId) => loanKbankId)
  );
};

export const excludeBuroBan = (loans = [], buroBanIds = new Set()) => {
  return loans.filter((loan) => {
    const loanKbankId = normalizeLoanKbankId(
      loan?.loan_kbank_id ?? loan?.original?.loan_kbank_id
    );
    return !buroBanIds.has(loanKbankId);
  });
};

// Export ต้องหยุดถ้าโหลดรายการ ban ไม่ได้ เพื่อไม่ให้สัญญาที่ ban หลุดเข้าไฟล์
export const fetchBuroBanIds = async () => {
  const data = await API.get("MoneyHubAdmin", "/buro/queryBuroBan", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`,
    },
  });

  if (!Array.isArray(data?.items)) {
    throw new Error("โหลดรายการ Buro Ban ไม่สำเร็จ จึงยังไม่สร้างไฟล์ Buro");
  }

  return getBuroBanIds(data.items);
};
